import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneMessage } from '@yy/one-ui'
import { saveFile } from '@/bizComponent/ServiceProvider/utils/index'
import { getOssAccessLinks } from '@/services/apis/common'
import { DownloadOutlined } from '@ant-design/icons'

export type FileDownload = {
  iconProps?: Record<string, any>
  filePath?: string
}

export const FileDownload: React.FC<FileDownload> = ({ iconProps, filePath }) => {
  const { t } = useTranslation()
  const { run, loading } = useRequest(
    () => {
      return getOssAccessLinks([
        {
          ossUri: filePath,
          fileType: 'invoicePath',
        },
      ]).then((res) => {
        const filePath = res.data.res?.[0]?.result

        if (filePath) {
          saveFile(filePath)
          OneMessage.success(t('common.success'))
        }
        return filePath
      })
    },
    {
      manual: true,
    }
  )
  return (
    <>
      {filePath ? (
        <Spin spinning={loading}>
          <DownloadOutlined
            {...iconProps}
            onClick={() => {
              run()
            }}
          />
        </Spin>
      ) : (
        '-'
      )}
    </>
  )
}
